import React from 'react';
import UncontrolledLottie from 'Lottie';
import PropTypes from 'prop-types';


const NotFound = ({ message }) => (
  <div style={{
    padding: 16, minHeight: '100vh', alignItems: 'center', display: 'flex', textAlign: 'center', justifyContent: 'center', flexDirection: 'column',
  }}
  >
    <UncontrolledLottie file="404-animation" />
    <h3>
      { message }
    </h3>
  </div>
);

NotFound.defaultProps = {
  message: 'No pudimos encontrar la página.',
};

NotFound.propTypes = {
  message: PropTypes.string,
};

export default NotFound;
